import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import userAgent from '@/services/userAgent.service';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLandscape',
  props: {
    bodyText: null,
    reversed: { type: Boolean },
    link: null,
    backgroundColor: { default: 'transparent' },
    textColor: null,
    buttonText: { default: undefined },
    buttonColor: { default: null },
    useFilledButton: { type: Boolean },
    isTextCentered: { type: Boolean }
  },
  setup(__props: any) {



const isInEditMode = computed<boolean>(() => store.getters['app/isInEditMode']);
const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const runAnimations = ref<boolean>(userAgent.isPrerender);

function initAnimations(): void {
    runAnimations.value = true;
}

return { __sfc: true,isInEditMode, theme, runAnimations, initAnimations }
}

})